import { component } from 'picoapp';
import Modal from '../../js/utils/modal';

export default component((node, ctx) => {
  /**
   * Data + elements
   */
  const closeBtn = node.querySelector('.js-closeBtn');
  const shopList = node.querySelector('.js-shopList');
  let shopItems;

  const shopItemClass = 'country-selector__shop-item';
  const shopItemActiveClass = 'country-selector__shop-item--active';

  const shops = [...window.theme.shops];
  const currentShop = shops.find((shop) => shop.shopifyDomain === Shopify.shop && shop.countryCode === Shopify.country)

  /**
   * Functions
   */
  const initModal = () => {
    const modal = Modal(node);

    ctx.on('countrySelector:open', () => modal.open());

    const close = () => {
      modal.close();
      sessionStorage.setItem('countrySelectorClosed', 'true');
    };

    closeBtn?.addEventListener('click', close);

    node.addEventListener('click', (event) => {
      if (event.target === node) {
        modal.close();
      }
    });

    ctx.on('countrySelector:close', close);
  };

  const initShopList = () => {
    // Move current shop to front of array
    const currentShopIndex = shops.indexOf(currentShop); // eslint-disable-line
    if (currentShopIndex !== -1) {
      const currentShopEntry = shops.splice(currentShopIndex, 1);
      shops.unshift(currentShopEntry);
    }

    window.theme.shops.forEach((shop) => {
      const listItem = document.createElement('li');
      shopList.appendChild(listItem);

      let itemClass = shopItemClass;
      if (shop.shopifyDomain === Shopify.shop && shop.countryCode === Shopify.country) {
        itemClass += ` ${shopItemActiveClass}`;
      }

      listItem.outerHTML = `<li class="${itemClass} js-shopItem" data-url="https://${shop.prettyUrl?.length ? shop.prettyUrl : shop.shopifyDomain}" ${shop === currentShop ? 'data-current="true"' : ''}>
          <img src="${shop.flagIcon}" class="country-selector__shop-item__flag-icon">
          <p class="country-selector__shop-item__title">${shop.title}</p>
          <p class="country-selector__shop-item__currency">(${shop.currency})</p>
      </li>`;
    });

    shopItems = shopList.querySelectorAll('.js-shopItem');
  };

  const initShopItems = () => {
    shopItems.forEach((item) => {
      item.addEventListener('click', () => {
        shopItems.forEach((i) => {
          i.classList[i === item ? 'add' : 'remove'](shopItemActiveClass);
        });
      });
    });
  };

  const initConfirmBtn = () => {
    shopItems.forEach((item) => {
      item.addEventListener('click', () => {
        const activeItem = Array.from(shopItems).find((item) => item.classList.contains(shopItemActiveClass)); // eslint-disable-line
        const activeIsCurrent = activeItem.dataset.current === 'true';

        if (activeIsCurrent) {
          ctx.emit('countrySelector:close');
        } else {
          const { url } = activeItem.dataset;
          window.location.href = url;
        }
      });
    });
  };

  const checkGeo = async () => {
    const { country_code: userCountryCode } = await fetch('https://get.geojs.io/v1/ip/geo.json').then((response) => response.json()); // eslint-disable-line
    const match = userCountryCode.toLowerCase() === currentShop.countryCode.toLowerCase() || currentShop.countryCode.toLowerCase() === 'international'; // eslint-disable-line

    if (!match && !sessionStorage.getItem('countrySelectorClosed')) {
      ctx.emit('countrySelector:open');
    }
  };

  const init = () => {
    initModal();
    initShopList();
    initShopItems();
    initConfirmBtn();
    checkGeo();
  };

  /**
   * Init
   */
  init();
});
